const serviceOldActionsPanel = {
  title: 'Pending Actions From Previous Services',
  title2: 'PENDING ACTIONS WITHOUT QUESTION FROM PREVIOUS SERVICES',
  accountable: 'Accountables: ',
  deadline: 'Deadline: ',
  serviceDate: 'Service Date: ',
  noAccountable: 'No accountable'
};

export default serviceOldActionsPanel;
